module.exports = __webpack_public_path__ + "img/klaus-krall.d491a85f.jpg";